'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMonthEndsBetweenDates = exports.isInputRangeLessThanOrEqualToGivenMonths = exports.isInputRangeLessThanOrEqualToThreeMonths = exports.generateChart = exports.getChartPrintHeight = exports.getChartPrintWidth = exports.generateChartId = exports.isInputRangeLessThanSixMonthOld = exports.isInputDateLessThanSixMonthOld = exports.createXAxisTicksForLessThanSixMonthOldFund = exports.createTicksFormattedInD3DateFormat = exports.createXAxisTicks = exports.calculateFinalTick = exports.calculateIntervalOfXAxisTicks = exports.calculateNumberOfXAxisTicks = exports.COMMON_CHART_CONFIG = undefined;

var _date_formatter = require('./date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _d = require('../../../src/main/resources/static/vendor/scripts/firevis-1.0.1/dependencies/d3-4.2.6/d3.min');

var d3 = _interopRequireWildcard(_d);

var _vendor = require('../../../app/implementation/vendor');

var _ramda = require('ramda');

var _functional_utility = require('./functional_utility');

var _chart_container = require('../../../app/implementation/components/chart_container');

var _chart_container2 = _interopRequireDefault(_chart_container);

var _string_utility = require('./string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _rolling_returns_chart = require('../../../app/implementation/components/charts/rolling_returns_chart');

var _rolling_returns_chart2 = _interopRequireDefault(_rolling_returns_chart);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHART_PRINT_WIDTH = 700;
var CHART_PRINT_HEIGHT = 500;
var BORDER_WIDTH = 1,
    ARROW_WIDTH = 20,
    OUTER_ARROW_BORDER = ARROW_WIDTH / 2,
    INNER_ARROW_BORDER = OUTER_ARROW_BORDER - BORDER_WIDTH,
    ARROW_HEIGHT = 10,
    INNER_ARROW_HEIGHT = ARROW_HEIGHT - BORDER_WIDTH;
var COMMON_CHART_CONFIG = exports.COMMON_CHART_CONFIG = {
  "container": {
    "height": 500
  },
  "scaled": true,
  "dateFormat": "%Y-%m-%d",
  "hoverLine": {
    "show": true,
    "lineStyle": {
      "stroke-width": "1px",
      "stroke": "black",
      "stroke-dasharray": 3
    },
    "circleStyle": {
      "radius": 5,
      "opacity": 0.7
    },
    "tooltip": {
      "type": "html",
      "show": true,
      "style": {
        "color": "#2b2b2b",
        "font-family": "NBInternational",
        "font-size": "15px",
        "font-weight": "300",
        "padding-top": "12px",
        "padding-bottom": "12px",
        "padding-right": "12px",
        "padding-left": "12px",
        "opacity": 0.95,
        "offsetX": 15,
        "offsetY": 5,
        "fill": "black",
        "background-color": "white",
        "border-width": 1,
        "border-style": "solid",
        "border-color": "#c9c9c9",
        "box-shadow": "0 4px 30px 0 rgba(0, 0, 0, 0.16)"
      },
      "left": function left(tooltipX, tooltipY, chart, tooltip, hoverline) {
        var parentContainerBCR = d3.select(chart.getTooltipContainer()).node().getBoundingClientRect();
        var visRect = hoverline.node().getBoundingClientRect();
        var toolRect = tooltip.select(".tool-text").node().getBoundingClientRect();

        var bounds = d3.select(chart.getSelector()).node().getBoundingClientRect();
        var leftBound = 0;
        var rightBound = bounds.right - bounds.left;
        var toolWidth = d3.select(chart.getSelector() + " .firevis-tooltip").node().getBoundingClientRect().width;

        if (tooltipX + chart.getMarginLeft() < toolWidth / 2) {
          return leftBound;
        } else if (tooltipX + leftBound + chart.getMarginLeft() + toolWidth / 2 > rightBound) {
          return rightBound - toolWidth;
        } else {
          return visRect.left - parentContainerBCR.left - toolRect.width / 2 - 10;
        }
      },
      "top": function top(tooltipX, tooltipY, chart, tooltip) {
        var toolRect = tooltip.node().getBoundingClientRect();

        if (tooltipY < toolRect.height) {
          return tooltipY + chart.getMarginTop() + ARROW_HEIGHT;
        } else {
          return tooltipY + chart.getMarginTop() - toolRect.height - ARROW_HEIGHT;
        }
      },
      "before": function before(tooltipX, tooltipY, chart, tooltip) {
        var bounds = d3.select(chart.getSelector()).node().getBoundingClientRect();
        var leftBound = 0;
        var rightBound = bounds.right - bounds.left;
        var toolWidth = tooltip.node().getBoundingClientRect().width;
        var toolHeight = tooltip.node().getBoundingClientRect().height;
        var style = {
          "content": "",
          "position": "absolute",
          "border-style": "solid",
          "border-color": "#c9c9c9 transparent",
          "display": "block",
          "width": "0"
        };
        if (tooltipY < toolHeight) {
          style["top"] = "-" + ARROW_HEIGHT + "px";
          style["border-width"] = "0 " + OUTER_ARROW_BORDER + "px " + OUTER_ARROW_BORDER + "px";
        } else {
          style["bottom"] = "-" + ARROW_HEIGHT + "px";
          style["border-width"] = OUTER_ARROW_BORDER + "px " + OUTER_ARROW_BORDER + "px 0";
        }
        if (tooltipX + chart.getMarginLeft() < toolWidth / 2) {
          style["left"] = tooltipX + chart.getMarginLeft() - OUTER_ARROW_BORDER + "px";
        } else if (tooltipX + leftBound + chart.getMarginLeft() + toolWidth / 2 > rightBound) {
          style["left"] = tooltipX + chart.getMarginLeft() + leftBound - (rightBound - toolWidth) - OUTER_ARROW_BORDER + "px";
        } else {
          style["left"] = toolWidth / 2 - OUTER_ARROW_BORDER + "px";
        }
        return style;
      },
      "after": function after(tooltipX, tooltipY, chart, tooltip) {
        var bounds = d3.select(chart.getSelector()).node().getBoundingClientRect();
        var leftBound = 0;
        var rightBound = bounds.right - bounds.left;
        var toolWidth = tooltip.node().getBoundingClientRect().width;
        var toolHeight = tooltip.node().getBoundingClientRect().height;
        var style = {
          "content": "",
          "position": "absolute",
          "border-style": "solid",
          "border-color": "#fff transparent",
          "display": "block",
          "width": "0"
        };
        if (tooltipY < toolHeight) {
          style["top"] = "-" + INNER_ARROW_HEIGHT + "px";
          style["border-width"] = "0 " + INNER_ARROW_BORDER + "px " + INNER_ARROW_BORDER + "px";
        } else {
          style["bottom"] = "-" + INNER_ARROW_HEIGHT + "px";
          style["border-width"] = INNER_ARROW_HEIGHT + "px " + INNER_ARROW_HEIGHT + "px 0";
        }
        if (tooltipX + chart.getMarginLeft() < toolWidth / 2) {
          style["left"] = tooltipX + chart.getMarginLeft() - OUTER_ARROW_BORDER + BORDER_WIDTH + "px";
        } else if (tooltipX + leftBound + chart.getMarginLeft() + toolWidth / 2 > rightBound) {
          style["left"] = tooltipX + chart.getMarginLeft() + leftBound - (rightBound - toolWidth) - OUTER_ARROW_BORDER + BORDER_WIDTH + "px";
        } else {
          style["left"] = toolWidth / 2 - OUTER_ARROW_BORDER + BORDER_WIDTH + "px";
        }

        return style;
      }
    }
  }
};

var chartUtility = {
  calculateIntervalOfXAxisTicks: function calculateIntervalOfXAxisTicks(startDate, endDate, isDesktop) {
    var diffMonths = endDate.diff(startDate, 'months', true);
    switch (true) {
      case diffMonths <= 0.2:
        return isDesktop ? 0.1 : 0.2; //decimals will be multiplied to calc units to represent days/weeks
        break;
      case diffMonths <= 0.4:
        return isDesktop ? 0.2 : 0.25;
        break;
      case diffMonths < 2:
        return isDesktop ? 0.25 : 0.5;
        break;
      case diffMonths <= 4:
        return isDesktop ? 0.5 : 1;
        break;
      case diffMonths <= 8:
        return isDesktop ? 1 : 2;
        break;
      case diffMonths <= 16:
        return isDesktop ? 2 : 3;
        break;
      case diffMonths <= 24:
        return isDesktop ? 3 : 6;
        break;
      case diffMonths <= 48:
        return isDesktop ? 6 : 12;
        break;
      default:
        return isDesktop ? Math.ceil(diffMonths / 8 / 12) * 12 : Math.ceil(diffMonths / 4 / 12) * 12;
    }
  },
  calculateFinalTick: function calculateFinalTick(startDate, endDate, isDesktop, startofMonth) {
    var diffMonths = endDate.diff(startDate, 'months', true);
    var newDate = void 0;
    switch (true) {
      case diffMonths <= 0.2:
        newDate = endDate.startOf('day');
        break;
      case diffMonths <= 0.4:
        newDate = isDesktop ? endDate.startOf('day') : endDate.startOf('week').add(1, 'd'); // add one day as start of week gives sunday (no data avaliable on sundays)
        break;
      case diffMonths <= 2:
        newDate = endDate.startOf('week').add(1, 'd');
        break;
      case diffMonths <= 4:
        newDate = isDesktop ? endDate.startOf('week').add(1, 'd') : startofMonth ? endDate.startOf("month") : endDate.endOf("month");
        break;
      case diffMonths <= 8:
        newDate = isDesktop ? endDate.startOf("month") : endDate.startOf("month");
        break;
      case diffMonths <= 16:
        newDate = isDesktop ? endDate.startOf("month") : endDate.startOf("quarter");
        break;
      case diffMonths <= 24:
        newDate = endDate.startOf("quarter");
        if (newDate.quarter() !== 1 && newDate.quarter() !== 3 && !isDesktop) {
          //quarter being calculated to give either jan or jul for bi-yearly ticks
          newDate.subtract(1, 'Q');
        }
        break;
      case diffMonths <= 48:
        newDate = isDesktop ? endDate.startOf("quarter") : endDate.startOf("year");
        if (newDate.quarter() !== 1 && newDate.quarter() !== 3) {
          newDate.subtract(1, 'Q');
        }
        break;
      default:
        newDate = isDesktop ? endDate.startOf("year") : endDate.startOf("year");
    }
    if (startofMonth || diffMonths <= 4) {
      return newDate;
    } else {
      return newDate.endOf('month');
    }
  },
  createXAxisTicks: function createXAxisTicks(endDate, isDesktop) {
    var numXAxisTicks = isDesktop ? 7 : 3;
    var tickInterval = isDesktop ? 1 : 3;
    var dateArray = _date_formatter2.default.getDatesFromGivenDateForGivenTickInterval(numXAxisTicks, endDate, tickInterval);
    var xAxisTicks = [];
    for (var i = numXAxisTicks - 1; i >= 0; i--) {
      /* eslint-disable*/
      xAxisTicks.push(d3.timeParse("%Y-%m-%d")(dateArray[i]));
      /* eslint-enable*/
    }
    return xAxisTicks;
  },
  createXAxisTicksForLessThanSixMonthOldFund: function createXAxisTicksForLessThanSixMonthOldFund(startDate, isDesktop) {
    var numXAxisTicks = isDesktop ? 7 : 3;
    var tickInterval = isDesktop ? 1 : 3;
    var dateArray = _date_formatter2.default.getFutureDatesFromGivenDateForGivenTickInterval(numXAxisTicks, startDate, tickInterval);
    var xAxisTicks = [];
    for (var i = 0; i <= numXAxisTicks - 1; i++) {
      /* eslint-disable*/
      xAxisTicks.push(d3.timeParse("%Y-%m-%d")(dateArray[i]));
      /* eslint-enable*/
    }
    return xAxisTicks;
  },
  createXAxisTicksForTwelveMonths: function createXAxisTicksForTwelveMonths(endDate, isDesktop) {
    var numXAxisTicks = isDesktop ? 6 : 3;
    var tickInterval = isDesktop ? 2 : 4;
    var dateArray = _date_formatter2.default.getDatesFromGivenDateForGivenTickInterval(numXAxisTicks, endDate, tickInterval);
    var xAxisTicks = [];
    for (var i = numXAxisTicks - 1; i >= 0; i--) {
      /* eslint-disable*/
      xAxisTicks.push(d3.timeParse("%Y-%m-%d")(dateArray[i]));
      /* eslint-enable*/
    }
    return xAxisTicks;
  },
  createXAxisTicksForDynamicRange: function createXAxisTicksForDynamicRange(startDate, endDate, isDesktop) {
    var dateArray = this.getMonthEndsBetweenDates(startDate, endDate, isDesktop, true);
    var xAxisTicks = [];

    dateArray.forEach(function (date) {
      var parsedDate = d3.timeParse("%Y-%m-%d")(date);
      if (!(0, _ramda.isNil)(parsedDate)) {
        xAxisTicks.push(parsedDate);
      }
    });

    return xAxisTicks;
  },
  createTicksFormattedInD3DateFormat: function createTicksFormattedInD3DateFormat(ticks) {
    var formattedTicks = [];
    for (var i = 0; i < ticks.length; i++) {
      /* eslint-disable*/
      formattedTicks.push(d3.timeParse("%Y-%m-%d")(ticks[i]));
      /* eslint-enable*/
    }
    return formattedTicks;
  },
  isInputDateLessThanSixMonthOld: function isInputDateLessThanSixMonthOld(shareClassInceptiondate) {
    var currentDate = (0, _moment2.default)();
    var monthsDiff = currentDate.diff(shareClassInceptiondate, 'months', true);
    if (monthsDiff < 6) {
      return true;
    } else {
      return false;
    }
  },
  isInputRangeLessThanSixMonthOld: function isInputRangeLessThanSixMonthOld(startDate, endDate) {
    var monthsDiff = (0, _moment2.default)(endDate).diff(startDate, 'months', true);
    return monthsDiff < 6;
  },
  isInputRangeLessThanOrEqualToThreeMonths: function isInputRangeLessThanOrEqualToThreeMonths(startDate, endDate) {
    var monthsDiff = (0, _moment2.default)(endDate).diff(startDate, 'months', true);
    return monthsDiff <= 3;
  },
  isInputRangeLessThanOrEqualToGivenMonths: function isInputRangeLessThanOrEqualToGivenMonths(startDate, endDate, months) {
    var monthsDiff = (0, _moment2.default)(endDate).diff(startDate, 'months', true);
    return monthsDiff <= months;
  },
  generateChartId: function generateChartId(id) {
    var isPrint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return isPrint ? id + '-print' : id;
  },
  getChartPrintWidth: function getChartPrintWidth() {
    return CHART_PRINT_WIDTH;
  },
  getChartPrintHeight: function getChartPrintHeight() {
    return CHART_PRINT_HEIGHT;
  },
  generateChart: function generateChart(id, chartType, data, spec) {
    /* eslint-disable*/
    return (0, _vendor.createReactFireVis)(id, chartType, data, spec);
    /* eslint-enable*/
  },
  getMonthEndsBetweenDates: function getMonthEndsBetweenDates(startDate, endDate, isDesktop, startOfMonth) {
    var date1 = (0, _moment2.default)(startDate);
    var date2 = (0, _moment2.default)(endDate);
    var dates = [];
    var interval = chartUtility.calculateIntervalOfXAxisTicks(date1, date2, isDesktop);
    var nextDate = chartUtility.calculateFinalTick(date1, date2, isDesktop, startOfMonth);
    dates.push(nextDate.format('YYYY-MM-DD'));
    var unit = void 0;
    var unitOfTime = void 0;
    if (interval >= 1) {
      unit = 'M';
      unitOfTime = 'month';
    } else if (interval >= 0.25) {
      interval *= 4;
      unit = 'w';
      unitOfTime = 'week';
    } else {
      interval *= 10;
      unit = 'd';
      unitOfTime = 'day';
    }
    while (nextDate >= date1) {
      nextDate = nextDate.subtract(interval, unit);
      if (startOfMonth || unitOfTime === 'week') {
        nextDate = (0, _moment2.default)(nextDate).startOf(unitOfTime);
      } else {
        nextDate = (0, _moment2.default)(nextDate).endOf(unitOfTime);
      }
      if (unitOfTime === 'week') {
        nextDate.add(1, 'd');
      }
      if (nextDate >= date1) {
        dates.push(nextDate.format('YYYY-MM-DD'));
      }
    }

    return dates.reverse();
  },
  getNearestRounding: function getNearestRounding(interval, seed, noZeroDP) {
    var nearestRounding = 10000;

    var level1 = seed * 0.25;
    var level2 = seed * 0.5;
    var level3 = seed * 1;

    if (interval >= 1 * seed && seed < nearestRounding) {
      nearestRounding = this.getNearestRounding(interval, seed * 10, noZeroDP);
    }

    if (interval <= level1) {
      nearestRounding = level1;
    } else if (interval > level1 && interval <= level2) {
      nearestRounding = level2;
    } else if (interval > level2 && interval < level3) {
      nearestRounding = level3;
    }

    if (noZeroDP) {
      nearestRounding = nearestRounding < 1 ? 1 : Math.floor(nearestRounding);
    }

    return nearestRounding;
  },
  renderRollingPeformanceChartCard: function renderRollingPeformanceChartCard(props) {
    if (!(0, _ramda.includes)('MONTHLY_ROLLING_PERF_CHART', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], props.fund)) || (0, _functional_utility.isNilOrEmpty)(props.fund.shareClass.monthlyRollingPerformanceReturns)) {
      return null;
    }

    var legend = [];
    if (!(0, _ramda.isNil)(props.fund.shareClass.fees.subscriptionFees)) {
      legend.push({ label: "Net of Fees", translationKey: "net-of-fees", color: "#B37E1B" });
    }
    legend.push({ label: props.fund.shareClass.monthlyRollingPerformanceReturns.rollingPerformanceData[0].performanceFactor, translationKey: "Shareclass", color: "#70C4FF" });
    legend.push({ label: "Benchmark", translationKey: "Benchmark", color: "#00A16D" });

    var rollingReturnsDisclosure = '';
    switch (props.fund.shareClass.fees.subscriptionFees) {
      case 5:
        rollingReturnsDisclosure = props.disclosures.pdpCardMonthlyRolling12Months5pct;
        break;
      case 3:
        rollingReturnsDisclosure = props.disclosures.pdpCardMonthlyRolling12Months3pct;
        break;
      case 0:
      case null:
        rollingReturnsDisclosure = props.disclosures.pdpCardMonthlyRolling12Months0pct;
        break;
      default:
        break;

    }
    return _react2.default.createElement(
      _chart_container2.default,
      {
        chartHeader: _string_utility2.default.renderFormattedLabel("Monthly rolling 12 months", "pdp-chart-monthly-rolling-header"),
        'data-testid': 'monthly-rolling-chart',
        chartAsOfDate: props.fund.shareClass.monthlyRollingPerformanceReturns.effectiveDate,
        gaiaRedirectUrl: props.gaiaRedirectUrl,
        cusip: props.cusip,
        country: props.country,
        role: props.role,
        id: 'monthly-rolling-chart',
        activeCardHandler: props.activeCardScrollHandler,
        breakpoint: props.breakpoint,
        disableButton: true,
        headerTitlelabel: 'rolling-returns-header',
        disclosureText: rollingReturnsDisclosure,
        placementId: 'rollingReturnsDisclosure',
        legend: legend,
        intl: props.intl
      },
      _react2.default.createElement(_rolling_returns_chart2.default, {
        rollingReturnsData: props.fund.shareClass.monthlyRollingPerformanceReturns,
        breakpoint: props.breakpoint,
        numberFormat: props.fund.numberFormat,
        gaiaRedirectUrl: props.gaiaRedirectUrl
      })
    );
  }
};

exports.default = chartUtility;
var calculateNumberOfXAxisTicks = chartUtility.calculateNumberOfXAxisTicks,
    calculateIntervalOfXAxisTicks = chartUtility.calculateIntervalOfXAxisTicks,
    calculateFinalTick = chartUtility.calculateFinalTick,
    createXAxisTicks = chartUtility.createXAxisTicks,
    createTicksFormattedInD3DateFormat = chartUtility.createTicksFormattedInD3DateFormat,
    createXAxisTicksForLessThanSixMonthOldFund = chartUtility.createXAxisTicksForLessThanSixMonthOldFund,
    isInputDateLessThanSixMonthOld = chartUtility.isInputDateLessThanSixMonthOld,
    isInputRangeLessThanSixMonthOld = chartUtility.isInputRangeLessThanSixMonthOld,
    generateChartId = chartUtility.generateChartId,
    getChartPrintWidth = chartUtility.getChartPrintWidth,
    getChartPrintHeight = chartUtility.getChartPrintHeight,
    generateChart = chartUtility.generateChart,
    isInputRangeLessThanOrEqualToThreeMonths = chartUtility.isInputRangeLessThanOrEqualToThreeMonths,
    isInputRangeLessThanOrEqualToGivenMonths = chartUtility.isInputRangeLessThanOrEqualToGivenMonths,
    getMonthEndsBetweenDates = chartUtility.getMonthEndsBetweenDates;
exports.calculateNumberOfXAxisTicks = calculateNumberOfXAxisTicks;
exports.calculateIntervalOfXAxisTicks = calculateIntervalOfXAxisTicks;
exports.calculateFinalTick = calculateFinalTick;
exports.createXAxisTicks = createXAxisTicks;
exports.createTicksFormattedInD3DateFormat = createTicksFormattedInD3DateFormat;
exports.createXAxisTicksForLessThanSixMonthOldFund = createXAxisTicksForLessThanSixMonthOldFund;
exports.isInputDateLessThanSixMonthOld = isInputDateLessThanSixMonthOld;
exports.isInputRangeLessThanSixMonthOld = isInputRangeLessThanSixMonthOld;
exports.generateChartId = generateChartId;
exports.getChartPrintWidth = getChartPrintWidth;
exports.getChartPrintHeight = getChartPrintHeight;
exports.generateChart = generateChart;
exports.isInputRangeLessThanOrEqualToThreeMonths = isInputRangeLessThanOrEqualToThreeMonths;
exports.isInputRangeLessThanOrEqualToGivenMonths = isInputRangeLessThanOrEqualToGivenMonths;
exports.getMonthEndsBetweenDates = getMonthEndsBetweenDates;